import { BaseEnum } from "../../../../enums/baseEnum";

const listEthicsChannelReportStatus: Array<EthicsChannelReportStatus> = [];

export class EthicsChannelReportStatus extends BaseEnum {
  public icon: string;
  public iconColor: string;
  public iconBackground: string;

  static CREATED = new EthicsChannelReportStatus(
    0,
    "CREATED",
    "Criado",
    "info",
    "edit-2",
    "#0D6EFD", // azul - neutro
    "#0D6EFD29" // azul claro transparente
  );
  static SENT = new EthicsChannelReportStatus(
    1,
    "SENT",
    "Enviado",
    "secondary",
    "send",
    "#6C757D", // cinza - neutro/intermediário
    "#6C757D29"
  );
  static UNDER_ANALYSIS = new EthicsChannelReportStatus(
    2,
    "UNDER_ANALYSIS",
    "Em Análise",
    "warning",
    "clock",
    "#FD7E14", // laranja - atenção
    "#FD7E1429"
  );
  static FINISHED = new EthicsChannelReportStatus(
    3,
    "FINISHED",
    "Finalizado",
    "success",
    "check",
    "#28C76F", // verde - sucesso
    "#28C76F29"
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string,
    icon: string,
    iconColor: string,
    iconBackground: string
  ) {
    super(id, value, label, className);
    this.icon = icon;
    this.iconColor = iconColor;
    this.iconBackground = iconBackground;
    listEthicsChannelReportStatus.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEthicsChannelReportStatus;
  }

  public static customBuildListEnum(): Array<BaseEnum> {
    return listEthicsChannelReportStatus.filter(
      (item) =>
        item !== EthicsChannelReportStatus.CREATED &&
        item !== EthicsChannelReportStatus.SENT
    );
  }

  public static getBy(value: string): EthicsChannelReportStatus {
    return listEthicsChannelReportStatus.find(
      (p: EthicsChannelReportStatus) => p.value === value
    );
  }

  public static getById(id: number): EthicsChannelReportStatus {
    return listEthicsChannelReportStatus.find(
      (p: EthicsChannelReportStatus) => p.id === id
    );
  }
}
